import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BotApiTokenService } from 'src/app/shared/services/bot-api-token.service';

export const externalapiResolver: ResolveFn<boolean> = async (_route, _state) => {
  const apiTokenService = inject(BotApiTokenService);
  await apiTokenService.loadApiTokens();
  return true;
};
